import React, { useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { useHistory } from "react-router-dom";
import { Loader } from 'pixi.js'
import { ErrorBoundary } from 'react-error-boundary'

import { getStudentCoins } from '../../../actions/share-actions';
import { GetLearningContentByLearningContentId, GetListEmojis, updateViewedLearningContent } from '../../../actions/learningcontent-actions';
import Loading from '../../shared/Loading'
import LearningContentDetailsHolder from './LearningContentDetailsHolder';
import { DefaultLayout, ProgressBarHeader, BreadcrumbsCustom } from '../../shared/component'
import useStyles from '../../../styles/components/learningcontent/stylesLearningContents'
import ErrorFallback from '../../shared/ErrorFallback'

import { StudentProfile } from '../../../utils/services/cache/ClientCache'
import { getStudentNumberFromSession, getLearningContentLevel, setTime } from '../../../utils/helpers/others/SessionHelper'
import { getIconLearningContent } from '../../../utils/helpers/icon/iconHelper';

const LearningContent = () => {
    const history = useHistory();
    const classes = useStyles();
    const learningContentSession = JSON.parse(localStorage.getItem('learningContent'));
    const [learningContent, setLearningContent] = React.useState({});
    const [listEmojis, setListEmojis] = React.useState([])
    const [loading, setLoading] = React.useState(true);
    const levelText = getLearningContentLevel()
    const loader = Loader.shared; // PixiJS exposes a premade instance for you to use.

    useEffect(() => {

        setTime(new Date().getTime());

        const initLearningContent = async () => {
            const learningContentResponse = await GetLearningContentByLearningContentId(learningContentSession.learningContentId);
            if (learningContentResponse > 200 || learningContentResponse.status === "Failed") {
                return history.push("/SessionTimeOut")
            }

            let learningContentVar = learningContentResponse.data;
            setLearningContent(learningContentVar);
        }

        const initListEmojis = async () => {
            const response = await GetListEmojis()
            if (response > 200 || response.status === "Failed") {
                return history.push("/SessionTimeOut")
            }

            const listEmojis = response.data;
            setListEmojis(listEmojis)
        }

        const initStudentCoins = async () => {
            const response = await getStudentCoins();
            if (response.status === "Success") {
                StudentProfile.setRewardPoint(response.data);
            }

        };

        const updateViewedLC = async (traitGroupId, learningContentId, studentNumber) => {
            await updateViewedLearningContent(traitGroupId, learningContentId, studentNumber);
        };

        initStudentCoins();
        initLearningContent();
        initListEmojis();
        updateViewedLC(
            learningContentSession.learningContentCategoryId,
            learningContentSession.learningContentId,
            getStudentNumberFromSession()
        )

        loader
            .add("./assets/images/spritesheets/coin.json")
            .load(setup);

        return () => loader.reset();

    }, []);

    const setup = () => setLoading(false);

    const breadcrumbsData = [
        {
            text: 'Learning Resources',
            href: '/LearningContentCategories'
        },
        {
            text: learningContentSession.learningContentCategoryName,
            href: learningContentSession.learningContentCategoryId === 0 ? '/NonTraitLearningContents' : '/LearningContents'
        },
        {
            text: learningContent.title,
            href: ''
        },
    ];

    if (loading) return <Loading />;

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <DefaultLayout
                title={learningContentSession.learningContentCategoryName}
                type='Learning Content'
                description=''
                image={getIconLearningContent().img_lc_bg_header}
                progressBar={learningContentSession.learningContentCategoryId !== 0 && <ProgressBarHeader levelText={levelText > 5 ? 5 : levelText} isExtraMax={levelText > 5 ? true : false} />}
            >
                <Grid container>
                    <Grid item xs={3} classes={{ root: classes.rootGridTabsContainer }} />
                    <Grid item xs={12} lg={6} classes={{ root: classes.rootGridContentContainer }}>
                        <BreadcrumbsCustom breadcrumbsData={breadcrumbsData} />
                        {Object.keys(learningContent).length !== 0 &&
                            <LearningContentDetailsHolder
                                learningContentDetails={learningContent}
                                listEmojis={listEmojis}
                                updateLC={(lc) => setLearningContent(lc)}
                            />
                        }
                    </Grid>
                </Grid>
            </DefaultLayout>
        </ErrorBoundary>
    )
}

export default LearningContent;